import DialogContext from 'context/DialogContext';

export const DialogConsumer = DialogContext.Consumer;
